import actionTypes from '../actions/action-types';

const initialState = {
  draft: false,
  defaultContactPhone: '',
  contactList: {},
  isMaintenance: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LOTTERY_CONTACTS_SUCCESS:
      return { ...state, ...action.contact };
    case actionTypes.FETCH_LOTTERY_CONTACTS_FAILURE:
      return { ...state, isMaintenance: true };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/contact/reducers/lottery.js